var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-overlay',{staticClass:"modal-root",attrs:{"isOpen":!!_vm.currentComponent,"popup-alignment":_vm.popupAlignment}},[_c(_vm.currentComponent,_vm._b({tag:"component",on:{"close":_vm.handleClose}},'component',_vm.props,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ee1135","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modal/ModalRoot.vue
// module id = null
// module chunks = 